import type { IClientInterface } from '~/types/auth/identityTypes'
import * as Sentry from '@sentry/vue'
import { useIdentity } from '~/store/identity'
import { requestHostHeaders } from '~/composables/constants/api'
import type { RequestHostHeadersType } from '~/composables/constants/api'

export const useCurrentUser = () => {
  const nuxt = useNuxtApp()

  const fetch = async () => {
    const response = await $fetch<{ user: IClientInterface }>('/api/auth/getCurrentUser', {
      method: 'POST',
      retry: 3,
      retryDelay: 100,
      headers: useRequestHeaders<RequestHostHeadersType>(requestHostHeaders),
    }).catch((error) => {
      Sentry.captureException(error, (scope) => {
        scope.setContext('Server Response', error.data)

        return scope
      })

      return { user: null }
    })

    if (response.user) {
      return response.user
    }

    return null
  }

  const isLoggedIn = async (refreshUser?: boolean): Promise<boolean> => {
    if (nuxt.ssrContext) {
      const user = await fetch()

      return user !== null
    }

    if (refreshUser) {
      await useIdentity().refresh()
    }

    const user = await useIdentity().getUser()

    return user !== null
  }

  return {
    fetch,
    isLoggedIn,
  }
}
